import { Link } from 'react-router-dom';
import Button from '../basic/Button';
import ButtonAnchor from '../basic/ButtonAnchor';

const Games = () => {
  return (
    <main>

      <section className="articles">

        <article className="left-image">

          <img src="/images/games/roadriches_appicon.png" alt="Road Riches Appicon" />
          <div>

            <h4 className="road-riches">Road Riches</h4>
            <p>
              Road Riches is an idle game where you upgrade a road to earn more and more money. You upgrade the number of lanes, the quality and the speed limit to build the best road possible!
            </p>
            <ButtonAnchor className="road-riches" to="https://apps.apple.com/gb/app/road-riches/id6474777652" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/juggletap_appicon.png" alt="Juggle Tap Appicon" />
          <div>

            <h4 className="juggle-tap">Juggle Tap</h4>
            <p>
              Juggle Tap is a casual game where you tap the screen to move a ball around the screen, avoiding obstacles for as long as possible. You could travel to the end of the level in Race, travel as far up as you can in Rise, or keep the ball up for as long as possible in Classic Mode.
            </p>
            <ButtonAnchor className="juggle-tap" to="https://apps.apple.com/gb/app/juggle-tap/id6472617042" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/leafbuster_appicon.png" alt="Leaf Buster Appicon" />
          <div>

            <h4 className="leaf-buster">Leaf Buster</h4>
            <p>
              Leaf Buster is a casual game where you have to tap leaves to destroy them before they hit your defence. If they hit your defence, they will do damage, and when it completely breaks, the game is over. You can upgrade your defence with tokens, and unlock new themes as you level up.
            </p>
            <ButtonAnchor className="leaf-buster" to="https://apps.apple.com/gb/app/leaf-buster/id6463021649" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/mountainrush_appicon.png" alt="Mountain Rush Appicon" />
          <div>

            <h4 className="mountain-rush">Mountain Rush</h4>
            <p>
              Mountain Rush is an exciting casual game where you roll and jump through a randomly generated level, avoiding new and unique obstacles, and collecting crystals to unlock new marbles!
            </p>
            <ButtonAnchor className="mountain-rush" to="https://apps.apple.com/gb/app/mountain-rush/id1638345622" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/mergecoin_appicon.png" alt="Merge Coin Appicon" />
          <div>

            <h4 className="merge-coin">Merge Coin</h4>
            <p>
              Merge Coin is an amazing idle game where you buy and merge coins, to increase your earnings. Buy boosters to increase the productivity of your bank and become a quadrillionaire!
            </p>
            <ButtonAnchor className="merge-coin" to="https://apps.apple.com/gb/app/merge-coin/id1611803907" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/fruitsort_appicon.png" alt="Fruit Sort Appicon" />
          <div>

            <h4 className="fruit-sort">Fruit Sort</h4>
            <p>
              My fourth game, Fruit Sort, is a unique platformer where you leap from platform to platform, delivering the falling fruit to the correct bowls before you run out of time! You have 5 lives, one replenishing every 2 minutes, but can get unlimited lives with Premium. Premium also unlocks 5 bonus levels on top of the existing 15!
            </p>
            <ButtonAnchor className="fruit-sort" to="https://apps.apple.com/gb/app/fruit-sort/id1611397729" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/bouncybird_appicon.png" alt="Bouncy Bird Appicon" />
          <div>

            <h4 className="bouncy-bird">Bouncy Bird</h4>
            <p>
              My third game, Bouncy Bird, is a casual game where you have to guide the bird around the pipes, collecting gems. Gems can be used to buy upgrades, decreasing the bounciness of the bird and decreasing the speed, giving you more time! You can unlock different birds and themes, or buy the Cookie birds and themes!
            </p>
            <Button className="bouncy-bird" to="/games/bouncy-bird" text="Downloads and More" icon_path="/images/icons/down-icon.svg" alt_text="Down Arrow" />
            <ButtonAnchor className="bouncy-bird" to="/play/bouncy-bird/index.html" text="Play in browser!" icon_path="/images/icons/play-icon.svg" alt_text="Play Button" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/plankspin_appicon.png" alt="Plank Spin Appicon" />
          <div>

            <h4 className="plank-spin">Plank Spin</h4>
            <p>
              My second game, Plank Spin, is a unique casual game where you spin your plank as many times as possible while in the air to get points. This game is about precision and timing, spin too much or too little and you'll hit the barrier! Upgrade your plank to progress further!
            </p>
            <Button className="plank-spin" to="/games/plank-spin" text="Downloads and More" icon_path="/images/icons/down-icon.svg" alt_text="Down Arrow" />
            <ButtonAnchor className="plank-spin" to="/play/plank-spin/index.html" text="Play in browser!" icon_path="/images/icons/play-icon.svg" alt_text="Play Button" />
          
          </div>
          
        </article>

        <article className="left-image">

          <img src="/images/games/rollingrush_appicon.png" alt="Rolling Rush Appicon" />
          <div>

            <h4 className="rolling-rush">Rolling Rush</h4>
            <p>
              My first game, Rolling Rush, is a casual game where you steer your ball left and right and jump over the wide variety of obstacles you encounter on your mission to finish the level, or get the highest score with endless mode!
            </p>
            <Button className="rolling-rush" to="/games/rolling-rush" text="Downloads and More" icon_path="/images/icons/down-icon.svg" alt_text="Down Arrow" />
            <ButtonAnchor className="rolling-rush" to="/play/rolling-rush/index.html" text="Play in browser!" icon_path="/images/icons/play-icon.svg" alt_text="Play Button" />
          
          </div>
          
        </article>

      </section>
      
    </main>
  );
}

export default Games;